export default __webpack_public_path__ + "static/media/team3.ee3d9705.png";